import React from 'react';

export const If = ({ condition, children }: { condition: unknown; children: React.ReactNode }): JSX.Element => (
  <>{condition ? children : undefined}</>
);
